'use strict';

var dateFns = require('date-fns');
var parsers = require('../parsers.cjs');
var disassembleISODatePartToParts = require('./disassembleToParts/disassembleISODatePartToParts.cjs');
var isAnniversary = require('./isAnniversary.cjs');

function nthAnniversaryFrom(targetDate, baseDate) {
  if (isAnniversary(baseDate, targetDate)) {
    return disassembleISODatePartToParts(targetDate).year - disassembleISODatePartToParts(baseDate).year;
  }
  if (targetDate > baseDate) {
    return dateFns.differenceInYears(
      parsers.isoDatePartToDate(targetDate),
      parsers.isoDatePartToDate(baseDate)
    ) + 1;
  } else if (targetDate < baseDate) {
    return dateFns.differenceInYears(
      parsers.isoDatePartToDate(targetDate),
      parsers.isoDatePartToDate(baseDate)
    ) - 1;
  }
  throw new Error("nthAnniversaryFrom: \uC9C4\uC785 \uBD88\uAC00");
}

module.exports = nthAnniversaryFrom;
//# sourceMappingURL=nthAnniversaryFrom.cjs.map
